import style from "./DatePicker.module.scss";
import { AbsoluteBlock } from "UI/shared";
import { Picker } from "./components";
import cn from "classnames"
import { useState } from "react";

export function DatePicker({
  currentDate,
  onChangeDate,
}: {
  currentDate: string | { start: string, end: string },
  onChangeDate: (newDate: string, type?: "start" | "end") => void,
}) {
  const [activePreset, setActivePreset] = useState<1 | 7 | 14 | 30>()

  return (
    <AbsoluteBlock
      XAlign={typeof currentDate === "string" ? "center" : "left"}
      advancedAdaptive={typeof currentDate !== "string"}
      targetElement={
        <div className={style["date-input"]}>
          {
            typeof currentDate === "string"
              ? <span>{currentDate}</span>
              : <p> <span>{currentDate.start}</span> - <span>{currentDate.end}</span> </p>
          }
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
          >
            <path
              d="M1 6H16M4.33333 1V2.66667M12.6667 1V2.66667M3.5 8.5H5.16667M7.66667 8.5H9.33333M11.8333 8.5H13.5M3.5 11H5.16667M7.66667 11H9.33333M11.8333 11H13.5M3.5 13.5H5.16667M7.66667 13.5H9.33333M11.8333 13.5H13.5M3.66667 16H13.3333C14.2667 16 14.7335 16 15.09 15.8183C15.4036 15.6586 15.6586 15.4036 15.8183 15.09C16 14.7335 16 14.2667 16 13.3333V5.33333C16 4.39991 16 3.9332 15.8183 3.57668C15.6586 3.26307 15.4036 3.00811 15.09 2.84832C14.7335 2.66667 14.2667 2.66667 13.3333 2.66667H3.66667C2.73325 2.66667 2.26653 2.66667 1.91002 2.84832C1.59641 3.00811 1.34144 3.26307 1.18166 3.57668C1 3.9332 1 4.39991 1 5.33333V13.3333C1 14.2667 1 14.7335 1.18166 15.09C1.34144 15.4036 1.59641 15.6586 1.91002 15.8183C2.26653 16 2.73324 16 3.66667 16Z"
              stroke="#1b1b1d"
              strokeWidth="1.3"
              strokeLinecap="round"
            />
          </svg>
        </div>
      }
      content={
        typeof currentDate === "string"
          ? <Picker
            currentDate={currentDate || (new Date().getDate() + "." + (new Date().getMonth() + 1) + "." + new Date().getFullYear())}
            onChangeDate={onChangeDate}
          />
          : (
            <div className={style.range}>
              <div className="flex flex-col gap-[10px] justify-between max-lg:flex-row">
                <div className={style.presets}>
                  <button
                    className={cn(style.button, activePreset === 1 && style.button_active)}
                    onClick={() => {
                      const { start, end } = handlePresetClick(1)
                      setActivePreset(1)

                      onChangeDate(start, "start")
                      onChangeDate(end, "end")
                    }}
                  >
                    Сьогодні
                  </button>
                  <button
                    className={cn(style.button, activePreset === 7 && style.button_active)}
                    onClick={() => {
                      const { start, end } = handlePresetClick(7)
                      setActivePreset(7)

                      onChangeDate(start, "start")
                      onChangeDate(end, "end")
                    }}
                  >
                    Останні 7 днів
                  </button>
                  <button
                    className={cn(style.button, activePreset === 14 && style.button_active)}
                    onClick={() => {
                      const { start, end } = handlePresetClick(14)
                      setActivePreset(14)

                      onChangeDate(start, "start")
                      onChangeDate(end, "end")
                    }}
                  >
                    Останні 14 днів
                  </button>
                  <button
                    className={cn(style.button, activePreset === 30 && style.button_active)}
                    onClick={() => {
                      const { start, end } = handlePresetClick(30)
                      setActivePreset(30)

                      onChangeDate(start, "start")
                      onChangeDate(end, "end")
                    }}
                  >
                    Останні 30 днів
                  </button>
                </div>
                <button
                  className={cn(style.clear)}
                  onClick={() => {
                    setActivePreset(undefined)
                    onChangeDate("Початкова дата", "start")
                    onChangeDate("Кінцева дата", "end")
                  }}
                >
                  Скинути
                </button>
              </div>
              <div className="flex gap-[30px] max-lg:justify-around overflow-auto max-lg:px-[10px] max-lg:pb-[15px]">
                <Picker
                  currentDate={
                    (currentDate.start === "Початкова дата")
                      ? (new Date().getDate() + "." + (new Date().getMonth() + 1) + "." + new Date().getFullYear())
                      : currentDate.start
                  }
                  onChangeDate={(newDate) => {
                    if (currentDate.start) {
                      if (validateDateRange(newDate, currentDate.end)) {
                        onChangeDate(newDate, "start")
                      } else {
                        onChangeDate(newDate, "start")
                        onChangeDate("Кінцева дата", "end")
                      }
                    } else {
                      onChangeDate("Початкова дата", "start")
                    }
                  }}
                />
                <div className={style.divider}></div>
                <Picker
                  currentDate={
                    (currentDate.end === "Кінцева дата")
                      ? (1 + "." + (new Date().getMonth() + 2) + "." + new Date().getFullYear())
                      : currentDate.end
                  }
                  onChangeDate={(newDate) => {
                    if (currentDate.end) {
                      if (validateDateRange(currentDate.start, newDate)) {
                        onChangeDate(newDate, "end")
                      } else {
                        onChangeDate(newDate, "start")
                        onChangeDate("Кінцева дата", "end")
                      }
                    } else {
                      onChangeDate("Кінцева дата", "end")
                    }
                  }}
                />
              </div>
            </div>
          )
      }
    />
  )
}

function validateDateRange(start: string, end: string) {
  if ((start === "Початкова дата") || (end === "Кінцева дата")) return true;

  const parseDate = (dateStr: string) => {
    const [day, month, year] = dateStr.split('.').map(Number);
    return new Date(year, month - 1, day);
  };

  const startDate = parseDate(start);
  const endDate = parseDate(end);

  return startDate.getTime() <= endDate.getTime();
}

function handlePresetClick(days: number) {
  const today = new Date();
  const startDate = new Date();

  if (days !== 1) {
    startDate.setDate(today.getDate() - (days - 1));
  }

  const formatDate = (date: Date): string => {
    return date.toLocaleDateString("uk-UA", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).replace(/\//g, ".");
  };

  return {
    start: formatDate(startDate),
    end: formatDate(today)
  }
}